import {
  TPivotPresetName,
  TPivotReport,
  TPivotReportConfig,
  TPivotReportDataSource,
} from '@infotech-soe/merps/types/Reports';
import { CategoryName } from '@infotech-soe/metaschema';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TActionArgsValues } from '../../infrastructure/providers/abstract/IApiProvider';
import UniqueId from '../../services/uid/UniqueId';

import { failureAction, pendingAction, successAction } from './actionHandler';

interface PivotState {
  show: boolean;
  code: string;
  categoryName: CategoryName;
  dataset: UniqueId;
  config?: TPivotReportConfig;
  dataSource?: TPivotReportDataSource;
}

const initialState: PivotState = {
  show: false,
  code: '',
  categoryName: '',
  dataset: '',
};

const pivotSlice = createSlice({
  name: 'pivot',
  initialState,
  reducers: {
    open: pendingAction<
      PivotState,
      { dataset: UniqueId; command: string; args: TActionArgsValues }
    >((state, { payload: { dataset } }) => {
      state.dataset = dataset;
    }),
    openSuccess: successAction<
      PivotState,
      {
        code: string;
        categoryName: CategoryName;
        config?: TPivotReportConfig;
        dataSource?: TPivotReportDataSource;
      }
    >((state, { payload: { code, categoryName, config, dataSource } }) => {
      state.show = true;
      state.code = code;
      state.categoryName = categoryName;
      state.config = config;
      state.dataSource = dataSource;
    }),
    openFailure: failureAction(),
    close: pendingAction(),
    closeSuccess: successAction<PivotState>(state => {
      state.show = false;
      state.dataset = '';
      state.config = undefined;
      state.dataSource = undefined;
    }),
    closeFailure: failureAction(),
    openPreset(
      state,
      { payload }: PayloadAction<{ presetName: TPivotPresetName }>
    ) {
      if (state.config) {
        state.config.currentPreset = payload.presetName;
      }
    },
    savePreset: pendingAction<
      PivotState,
      { presetName: TPivotPresetName; report: TPivotReport; isClosed?: boolean }
    >(),
    savePresetSuccess: successAction<
      PivotState,
      { newConfig: TPivotReportConfig; isClosed?: boolean }
    >((state, { payload: { newConfig } }) => {
      state.config = newConfig;
    }),
    savePresetFailure: failureAction(),
  },
});

export const pivotReducer = pivotSlice.reducer;

export default pivotSlice.actions;
